import { getBulkData } from './getBulkData'
import { getData } from './getData'

export const TypeTicketActions = {
  getData,
  getBulkData,
}
